module.exports = __webpack_public_path__ + "static/media/s_jade_green.688e7e01.mp3";